var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModulePlasticSurgery from '../../schemas/module-plastic-surgery.json';
var SchemaModulePlasticSurgery = (function (_super) {
    __extends(SchemaModulePlasticSurgery, _super);
    function SchemaModulePlasticSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModulePlasticSurgery);
        return _this;
    }
    return SchemaModulePlasticSurgery;
}(SchemaModuleUniversal));
export { SchemaModulePlasticSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-plastic-surgery.ts.pre-build-optimizer.js